import React, { FC, useEffect, useState } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
    Button
} from '@material-ui/core';

interface TemplateFormValues {
    name: string;
    display_order: number;
}

interface AssessmentTemplateDialogProps {
    open: boolean;
    initialValues: TemplateFormValues;
    isEditing: boolean;
    onSubmit: (values: TemplateFormValues) => void;
    onClose: () => void;
}

const defaultValues: TemplateFormValues = {
    name: '',
    display_order: 0
};

const AssessmentTemplateDialog: FC<AssessmentTemplateDialogProps> = ({
    open,
    initialValues,
    isEditing,
    onSubmit,
    onClose
}) => {
    const [formValues, setFormValues] = useState<TemplateFormValues>(initialValues || defaultValues);

    useEffect(() => {
        if (open) {
            setFormValues(initialValues || defaultValues);
        }
    }, [initialValues, open]);

    const handleChange = (key: keyof TemplateFormValues) => (event: React.ChangeEvent<HTMLInputElement>) => {
        const value = key === 'display_order' ? Number(event.target.value) : event.target.value;
        setFormValues(prev => ({ ...prev, [key]: value }));
    };

    const handleSubmit = (event: React.FormEvent) => {
        event.preventDefault();
        if (!formValues.name.trim()) {
            return;
        }
        onSubmit({
            ...formValues,
            name: formValues.name.trim()
        });
    };

    return (
        <Dialog open={open} onClose={onClose} aria-labelledby="template-dialog-title" fullWidth maxWidth="sm">
            <form onSubmit={handleSubmit}>
                <DialogTitle id="template-dialog-title">{isEditing ? 'Edit template' : 'Add template'}</DialogTitle>
                <DialogContent>
                    <TextField
                        autoFocus
                        label="Template name"
                        value={formValues.name}
                        onChange={handleChange('name')}
                        margin="dense"
                        fullWidth
                        required
                    />
                    <TextField
                        label="Display order"
                        type="number"
                        value={formValues.display_order}
                        onChange={handleChange('display_order')}
                        margin="dense"
                        fullWidth
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={onClose} color="primary">
                        Cancel
                    </Button>
                    <Button color="primary" type="submit" variant="contained">
                        {isEditing ? 'Save' : 'Create'}
                    </Button>
                </DialogActions>
            </form>
        </Dialog>
    );
};

export type { TemplateFormValues };
export default AssessmentTemplateDialog;
